<div #icon class="flex flex-row justify-end items-center content-center h-full w-full">
    <mds-icon class="size-9 text-7xl" [icon]="customParams().icon" [color]="'warn'" [appearance]="'fill'"></mds-icon>
</div>
